import EventDispatcher from "../../common/EventDispatcher";
import { Global } from "../../common/global";

export default class Menu {
  constructor() {
    this.navContainer = document.querySelector("header>.content");
    this.navTrigger = document.querySelector("#nav-trigger");

    this.menuPrivacy = document.querySelector("#menuPrivacy");
    this.menuTerms = document.querySelector("#menuTerms");
    this.menuFAQ = document.querySelector("#menuFAQ");
    this.menuContact = document.querySelector("#menuContact");

    this.privacyBack = document.querySelector("#privacyBack");
    this.termsBack = document.querySelector("#termsBack");
    this.FAQBack = document.querySelector("#FAQBack");
    this.contactBack = document.querySelector("#contactBack");

    this.navTrigger.addEventListener(
      "click",
      this.showOrHideMenu.bind(this, null)
    );

    this.menuPrivacy.addEventListener(
      "click",
      this.hideAllAndShowByID.bind(this, "privacy_scr")
    );
    this.menuTerms.addEventListener(
      "click",
      this.hideAllAndShowByID.bind(this, "terms_scr")
    );
    this.menuFAQ.addEventListener(
      "click",
      this.hideAllAndShowByID.bind(this, "FAQ_scr")
    );
    this.menuContact.addEventListener(
      "click",
      this.hideAllAndShowByID.bind(this, "contact_scr")
    );

    this.privacyBack.addEventListener("click", this.goBack.bind(this));
    this.termsBack.addEventListener("click", this.goBack.bind(this));
    this.FAQBack.addEventListener("click", this.goBack.bind(this));
    this.contactBack.addEventListener("click", this.goBack.bind(this));
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));

    this.menuShown = false;
    document.querySelector("header").classList.add("active");
  }
  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_menu":
        document.querySelector("header").classList.add("active");
        break;
      case "hide_menu":
        document.querySelector("header").classList.remove("active");
        break;
    }
  }
  showOrHideMenu(status) {
    this.menuShown = status != null ? status : !this.menuShown;

    if (this.menuShown) {
      this.navTrigger.classList.add("active");
      this.navContainer.classList.add("active");
    } else {
      this.navTrigger.classList.remove("active");
      this.navContainer.classList.remove("active");
    }
  }
  hideAllAndShowByID(menuID) {
    this.showOrHideMenu(false);
    document.querySelector("#privacy_scr").classList.remove("active");
    document.querySelector("#terms_scr").classList.remove("active");
    document.querySelector("#FAQ_scr").classList.remove("active");
    document.querySelector("#contact_scr").classList.remove("active");

    if (menuID != null) {
      document.querySelector(`#${menuID}`).classList.add("active");
    }
  }
  goBack(v) {
    v.stopImmediatePropagation();
    this.showOrHideMenu(false);
    this.hideAllAndShowByID(null);
    // this.events.dispatchEvent({
    //     type: "GAMESCENE_EVENTS",
    //     message: {
    //       event_type: "show_screen",
    //       data: {
    //         screenKey: Global.goBackTo,
    //       },
    //     },
    //   });
  }
}
